import { RitzAPI, } from '@moderepo/mode-internal-apis';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var AppActionType;
(function (AppActionType) {
    AppActionType["SET_APP_SETTINGS"] = "set app settings";
})(AppActionType || (AppActionType = {}));
/*
 * Create an action to set app settings
 */
export const setAppSettings = (appSettings) => {
    return {
        type: AppActionType.SET_APP_SETTINGS,
        appSettings,
    };
};
/**
 * Create an action to fetch CS app settings
 */
export const fetchCSAppSettings = () => {
    return async (dataDispatch) => {
        const settings = await RitzAPI.getInstance().getAppSettings();
        await dataDispatch(setAppSettings(settings));
    };
};
